import React from 'react';
import HeroSlider from '../components/HeroSlider';
import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Projects from '../components/Projects';
import Education from '../components/Education';
import Publications from '../components/Publications';
import BlogSection from '../components/BlogSection';
import Contact from '../components/Contact';

export default function Home() {
  return (
    <main>
      <HeroSlider />
      <About />
      <Skills />
      <Experience />
      <Projects />
      <Education />
      <Publications />
      <BlogSection />
      <Contact />
    </main>
  );
}
